import QRCode from 'react-qr-code';

import Icon from 'components/common/Icon';
import Tooltip from 'components/common/Tooltip';
import IconBackground from 'components/common/icons/IconBackground';

const QRCodePopup = ({ link }: { link: string }) => {
  return (
    <IconBackground>
      <Tooltip
        trigger={
          <div className="w-4 h-4">
            <Icon id="qr-code" />
          </div>
        }
      >
        <QRCode value={link} />
      </Tooltip>
    </IconBackground>
  );
};

export default QRCodePopup;
